import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next");
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(form.email, form.password);
      toast.success("Welcome back.");
      let dest = next;
      if (!dest) {
        if (u?.is_admin) dest = "/dashboard";
        else if (u?.is_coordinator || u?.is_org_admin) dest = "/crm";
        else if (u?.is_section_leader) dest = "/attendance/section";
        else if (u?.is_teacher) dest = "/teacher";
        else dest = "/dashboard";
      }
      navigate(dest);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not sign in.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-24" data-testid="login-page">
      <div className="overline mb-3">Welcome back</div>
      <h1 className="font-serif-display text-4xl tracking-tight" style={{ color: "var(--ink)" }}>Sign in</h1>
      <form onSubmit={onSubmit} className="mt-8 space-y-5">
        <div>
          <label className="block text-xs mb-2 overline">Email</label>
          <input
            type="email"
            required
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            data-testid="login-email-input"
            className="w-full bg-white border px-4 py-3 outline-none focus:border-[var(--terracotta)]"
            style={{ borderColor: "var(--border-strong)", color: "var(--ink)" }}
          />
        </div>
        <div>
          <label className="block text-xs mb-2 overline">Password</label>
          <input
            type="password"
            required
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            data-testid="login-password-input"
            className="w-full bg-white border px-4 py-3 outline-none focus:border-[var(--terracotta)]"
            style={{ borderColor: "var(--border-strong)", color: "var(--ink)" }}
          />
        </div>
        <button type="submit" disabled={busy} data-testid="login-submit-button" className="btn-primary w-full justify-center disabled:opacity-50">
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
      <p className="mt-8 text-sm" style={{ color: "var(--ink-2)" }}>
        New here? <Link to="/register" data-testid="login-register-link" className="underline" style={{ color: "var(--terracotta)" }}>Create an account</Link>
      </p>
    </div>
  );
}
